"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-secondary-foreground/10 animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-2.5">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-secondary-foreground/80 hover:text-white transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SiteFooter() {
  return <footer id="site-footer" className="bg-secondary text-secondary-foreground pt-16 pb-8">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="block">
              
            </Link>
            <p className="text-secondary-foreground/80 text-sm leading-relaxed max-w-xs">
              Serving the Abilene community with integrity. We specialize in comprehensive property management services, handling both short-term and long-term leases with a focus on owner and renter needs.
            </p>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="48" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-serif font-bold text-white mb-6 tracking-tight">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-white shrink-0 mt-0.5" />
                <Link to="https://www.google.com/maps/search/?api=1&query=Abilene+Texas" newTab className="text-sm text-secondary-foreground/80 hover:text-white transition-colors">
                  Abilene, Texas
                </Link>
              </li>
              <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone w-5 h-5 text-white shrink-0" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:e16lun" data-ast-start="3085" data-ast-end="3134"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><a className="text-sm text-secondary-foreground/80 hover:text-white transition-colors" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:sl1192" data-ast-start="3151" data-ast-end="3373" href="tel:+13255551234">(325) 529-3020</a></li>
              <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail w-5 h-5 text-white shrink-0" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:ybknyb" data-ast-start="3742" data-ast-end="3790"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg><a className="text-sm text-secondary-foreground/80 hover:text-white transition-colors" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:sl1192" data-ast-start="3807" data-ast-end="4005" href="mailto:info@tailletrealestate.com">taillet.realestate@gmail.com</a></li>
            </ul>
          </div>

          {}
          
        </div>

        <Separator className="bg-secondary-foreground/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-secondary-foreground/50">
          <p>
            &copy; {new Date().getFullYear()} Taillet Real Estate and Property Management. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-white transition-colors">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}